import SystemValueList from "../../../../components/SystemValue/SystemValueList";

const COLUMNS = [
  { header: "Name", render: (s) => s.name || "—" },
];

const ServiceList = ({ services, onEdit, onDelete }) => (
  <SystemValueList
    items={services}
    columns={COLUMNS}
    onEdit={onEdit}
    onDelete={onDelete}
    emptyMessage="No services added yet."
  />
);

export default ServiceList;
